import React from 'react';

interface State {
  projectName: string;
  projectShortName: string;
  email: string;
}

interface AppConfigContextProviderProps {
  value?: State;
  children: React.ReactNode;
}

const AppConfigStateContext = React.createContext<State | undefined>(undefined);

export const AppConfigContextProvider: React.FC<AppConfigContextProviderProps> = ({ value, children }) => {
  const [state] = React.useState(value);

  return <AppConfigStateContext.Provider value={state}>{children}</AppConfigStateContext.Provider>;
};

export const useAppConfigStateContext = (): State => {
  const state = React.useContext(AppConfigStateContext);
  if (typeof state === 'undefined') {
    throw new Error('useAppConfigStateContext must be used within a AppConfigStateContextProvider');
  }
  return state;
};
